<ng-container [formGroup]="fg">
  <label
    appConfigSettingsParagraph
    class="displayInLine"
    *ngIf="placeholder != undefined"
    [style.color]="fontColor ? fontColor : null"
    [style.font-size.px]="fontSize ? fontSize : null"
  >
    <p>
      {{placeholderPrefix ? placeholderPrefix + ' ' : ''}}{{ placeholder | translate }}
    </p>
    <div
      *ngIf="additionalInfoInsurer!=null"
    >
      <mat-icon class="infoIcon" (click)="openPopup()" type="button">info</mat-icon>
    </div>
  </label>
  <div
    *ngIf="freeText"
    [style.color]="fontColor ? fontColor : null"
    [style.font-size.px]="fontSize ? fontSize : null"
  >
    {{ freeText | translate }}
  </div>
  <br *ngIf="breaks" />
  <div
    *ngIf="cofigBlock;else currentBlock"
  >
    <mat-button-toggle-group
      [formControl]="control"
      [class.groupBy2InLine]="groupBy2InLine"
      value="optionsList[0].value"
    >
      <div
        *ngFor="let option of optionsList"
        [style.background-color]="backgroundColor"
        [style.color]="backgroundTextColor"
        class="optionStyle"
      >
        <mat-button-toggle
          [disabled]="disabled"
          appConfigSettingsBorder
          appConfigSettingsInput
          [style.borderColor]="inputBorderColor ? inputBorderColor : null"
          [value]="option.value"
          [style.fontFamily]="FontTypeEnum[configSettings.fontType]"
          [style.color]="inputColor ? inputColor : null"
        >
          {{ option.text | translate }}
        </mat-button-toggle>
      </div>
    </mat-button-toggle-group>
  </div>
  <ng-template #currentBlock>
    <mat-button-toggle-group
      [formControl]="control"
      [class.groupBy2InLine]="groupBy2InLine"
      value="optionsList[0].value"
    >
      <div
        *ngFor="let option of optionsList"
        appConfigSettingsPrimaryButton
        class="optionStyle"
      >
        <mat-button-toggle
          appConfigSettingsBorder
          appConfigSettingsInput
          [disabled]="option.disabled || disabled"
          [style.borderColor]="inputBorderColor ? inputBorderColor : null"
          [value]="option.value"
          [style.fontFamily]="FontTypeEnum[configSettings.fontType]"
          [style.color]="inputColor ? inputColor : null"
        >
          {{ option.text | translate }}
        </mat-button-toggle>
      </div>
    </mat-button-toggle-group>
  </ng-template>
  <div>
    <mat-error *ngIf="isAnyError" class="error-message">
      <ng-container *ngIf="messageError">
        {{ control.errors.message }}
      </ng-container>
      <ng-container *ngIf="requiredError">
        {{ isRequiredMessage }}
      </ng-container>
    </mat-error>
  </div>
</ng-container>
